// Inference backend (Express) — only for AI chat/LLM calls
export const INFERENCE_URL = process.env.NEXT_PUBLIC_INFERENCE_URL || 'http://localhost:1045';
export const WS_URL = process.env.NEXT_PUBLIC_WS_URL || 'ws://localhost:1045/ws';
export const APP_NAME = 'CTRL-A Workspace';
export const APP_VERSION = '3.0.0';

/**
 * Resolve the URL of workspace-main for server-side proxy routes.
 *
 * Historically every `src/app/api/**\/route.ts` inlined its own:
 *   const WORKSPACE_URL =
 *     process.env.WORKSPACE_MAIN_URL ||
 *     process.env.NEXT_PUBLIC_INFERENCE_URL ||
 *     'https://ctrl-a-workspace.onrender.com';
 *
 * In a dev `.env.local`, `WORKSPACE_MAIN_URL` is typically set to the prod
 * Render URL (so preview envs work), which means every proxied call in
 * local dev hits prod — prod has never seen the dev user → 401 on every
 * workflow/task/channel request.
 *
 * This helper flips precedence to prefer localhost in dev. Routes that
 * import `workspaceMainUrl()` get the local backend automatically when
 * `NODE_ENV === 'development'` AND `NEXT_PUBLIC_INFERENCE_URL` is set.
 */
export function workspaceMainUrl(): string {
  const dev = process.env.NODE_ENV === 'development';
  const fromEnv = process.env.WORKSPACE_MAIN_URL;
  const local = process.env.NEXT_PUBLIC_INFERENCE_URL;
  if (dev && local) return local;
  return fromEnv || local || 'https://ctrl-a-workspace.onrender.com';
}
